import Helper from '@/views/checklist/checklist-item/helper'
import ChecklistStatus from '@/status'
export default {
  getListChecklist (state) {
    return state.checklists
  },
  getListChecklistAll (state) {
    return state.checklistAll
  },
  getLastPage (state) {
    return state.last_page
  },
  getTotal (state) {
    return state.total
  },
  showChecklist (state) {
    return state.checklist.checklist_info
  },
  getGroupOfChecklist (state) {
    var chooice = []
    state.checklist.group_of_checklists.forEach(group => {
      Helper.getUnNestedChildren(group).forEach(element => {
        element.checklistitems = element.chk_items
        // delete element.chk_items
      })
      chooice.push(group)
    })
    return chooice
  },
  getField (state) {
    return state.fields
  },
  getCalendarChecklist (state) {
    var events = []
    state.checklists.forEach(checklist => {
      var data = {}
      if (parseInt(checklist.status.code) === parseInt(ChecklistStatus.CORRECTIVE) || parseInt(checklist.status.code) === parseInt(ChecklistStatus.INPROGRESS)) {
        data = {
          id: checklist.id,
          title: checklist.name + '(' + checklist.organization.name + ')',
          startDate: parseInt(checklist.status.code) === parseInt(ChecklistStatus.CORRECTIVE) ? checklist.start_corrective_date : checklist.starting_date,
          endDate: parseInt(checklist.status.code) === parseInt(ChecklistStatus.CORRECTIVE) ? checklist.end_corrective_date : checklist.ending_date,
          classes: checklist.status.code === parseInt(ChecklistStatus.CORRECTIVE) ? 'orange' : 'green'
        }
        events.push(data)
      }
    })
    return events
  },
  getCalendarChecklistInProgress (state) {
    console.log(state)
    var events = []
    state.checklists.forEach(checklist => {
      var data = {}
      if (parseInt(checklist.status.code) === parseInt(ChecklistStatus.INPROGRESS)) {
        data = {
          id: checklist.id,
          title: checklist.name + '(' + checklist.organization.name + ')',
          startDate: parseInt(checklist.status.code) === parseInt(ChecklistStatus.CORRECTIVE) ? checklist.start_corrective_date : checklist.starting_date,
          endDate: parseInt(checklist.status.code) === parseInt(ChecklistStatus.CORRECTIVE) ? checklist.end_corrective_date : checklist.ending_date,
          classes: checklist.status.code === parseInt(ChecklistStatus.CORRECTIVE) ? 'orange' : 'green'
        }
        events.push(data)
      }
    })
    return events
  },
  getChecklistYesterday (state) {
    var checklistYesterdays = []
    var yesterdayDate = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().substr(0, 10)
    state.checklists.forEach(checklist => {
      if (checklist.status.code === parseInt(ChecklistStatus.CORRECTIVE) || checklist.status.code === parseInt(ChecklistStatus.INPROGRESS)) {
        if (yesterdayDate >= checklist.starting_date && yesterdayDate <= checklist.ending_date) {
          checklistYesterdays.push(checklist)
        }
      }
    })
    return checklistYesterdays
  },
  getChecklistToday (state) {
    var checklistToday = []
    var todayDate = new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10)
    state.checklists.forEach(checklist => {
      if (checklist.status.code === parseInt(ChecklistStatus.CORRECTIVE) || checklist.status.code === parseInt(ChecklistStatus.INPROGRESS)) {
        if (todayDate >= checklist.starting_date && todayDate <= checklist.ending_date) {
          checklistToday.push(checklist)
        }
      }
    })
    return checklistToday
  },
  getChecklistTomorrow (state) {
    var checklistTomorrow = []
    var yesterdayTomorrow = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().substr(0, 10)
    state.checklists.forEach(checklist => {
      if (checklist.status.code === parseInt(ChecklistStatus.CORRECTIVE) || checklist.status.code === parseInt(ChecklistStatus.INPROGRESS)) {
        if (yesterdayTomorrow >= checklist.starting_date && yesterdayTomorrow <= checklist.ending_date) {
          checklistTomorrow.push(checklist)
        }
      }
    })
    return checklistTomorrow
  },
  getChecklistPermission (state) {
    return state.checklist_permissions
  }
}



// WEBPACK FOOTER //
// ./src/store/module/checklist/getters.js